var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',[_c('div',{staticClass:"mb-1"},[_c('i',{staticClass:"ml-2 fa fa-handshake fa-lg"}),_c('span',{staticClass:"h6 ml-2"},[_vm._v(_vm._s(_vm.$t('menu.agreements.index')))])]),_c('hr',{staticClass:"mt-1 mb-1"}),_c('Table')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }